<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <div class="title">基本信息</div>
      <div>订单状态：{{ detailData.txt_status }}</div>

      <div>订单类型：{{ detailData.good_type }}</div>
      <div>订单号：{{ detailData.order_id }}</div>
      <div>下单时间：{{ detailData.create_at }}</div>
      <div>订单总价格：{{ detailData.order_amount_total }}</div>
      <div v-if="detailData.order_status==2 || detailData.order_status==3 ||detailData.order_status==4">区域：{{ detailData.buType }}</div>
      <div v-if="show==1 && detailData.order_status>2&& detailData.order_status!==3&& detailData.order_status!==4">
        <!-- 后台取消订单 全部-1 待支付0 待确认1 ,待发货2,已发货3 ,已完成4, 退款5 取消6 -->
        <el-button type="info" plain @click="editOrderQuyu" >
        修改区域</el-button>
      </div>

      <div >订单备注：{{ detailData.beizhu }}</div>
      
    </el-card>

    <el-card v-if="detailData.addressName">
      <div v-if=" detailData.order_status == 3 ||detailData.order_status == 4">
        <div class="title">送货信息</div>
        <div>送货人姓名：{{ detailData.sendName }}</div>
        <div>送货人电话：{{ detailData.sendPhone }}</div>
      </div>

      <div class="title">收货人信息</div>
      <div>收货联系人：{{ detailData.addressName }}</div>
      <div>联系人电话：{{ detailData.addressPhone }}</div>
      <div>收货地址：{{ detailData.addressDetail }}</div>
    </el-card>

    <el-card v-if="detailData.order_status == 5">
      <div class="title">退款信息</div>
      <div>退款金额：{{ detailData.refund.tuikuanMoney }}</div>
      <div>退款联系电话：{{ detailData.refund.tuikuanPhone }}</div>
      <div>退款说明：{{ detailData.refund.tuikuanShuoming }}</div>
      <div>退款原因：{{ detailData.refund.tuikuanSeason }}</div>
      <div>
        退款凭证：
        <div class="block">
          <el-image
            style="width: 100px; height: 100px; margin-right: 20px"
            v-for="(fit, index) in detailData.refund.tuikuanPingzheng"
            :key="fit"
            :src="fit"
            fit="contain"
            :preview-src-list="getSrcList(index)"
          ></el-image>
        </div>
      </div>
      <div v-if="detailData.refund.tuikuanStatus == 0">退款状态：审核中</div>
      <div v-if="detailData.refund.tuikuanStatus == 1">退款状态：已通过</div>
      <div v-if="detailData.refund.tuikuanStatus == 2">退款状态：已拒绝</div>
      <div v-if="detailData.tuikuanStatus == 0">
        <el-button type="success" plain @click="agreenTuiKuan">通过申请</el-button>
        <el-button type="danger" plain @click="refuseTuiKuan">拒绝申请</el-button>
      </div>
    </el-card>

    <el-card>
      <div class="title">商品信息</div>
      <div>商品总价格：{{ detailData.order_amount_total }} 商品总数量：{{ detailData.totalNum }}</div>
      <!-- 订单列表数据 -->
      <el-table v-if="detailData.order_status != 0" :data="detailData.goods_info" border stripe tooltip-effect="dark" style="width: 100%">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="商品名称" prop="title" width="120px"> </el-table-column>
        <el-table-column label="商品规格" prop="preNum" width="120px"> </el-table-column>
        <el-table-column label="商品编号" prop="number" width="150px"></el-table-column>
        <el-table-column label="商品单价" prop="price" align="center" width="70px"> </el-table-column>
        <el-table-column label="件数" prop="buyNum" align="center" width="70px"> </el-table-column>
        <el-table-column label="参与活动" prop="activityContent" align="center" width="120px"> </el-table-column>
        <el-table-column label="赠送件数" prop="sendNumber" align="center" width="80px"> </el-table-column>
      </el-table>

      
    </el-card>

  </div>
</template>

<script>
import cityData from '../order/citydata.js'
import Goods from '../order/Goods.vue'
export default {
  components: {
    Goods
  },
  props:['valueId'],
  data () {
    return {
      visible:false,
      editOrderQuyuDialogVisible:false,
      show:1,
      radio:'1',
      detailData: {
        goods_info: null,
      },
      editForm: {
        id: 0,
        order_amount_total: 0,
        addressName: 0,
        addressPhone: 0,
        addressDetail: 0,
      },

      cancelForm: {
        cancelSeasion: null,
      },

      cancelVisible: false,
      cancelFormRule: {
        cancelSeasion: [
          { required: true, message: '取消理由不能为空', trigger: 'blur' }
        ],
      },
      editGoodForm: {
        buyNum: 0,
        g_id: 0,
      },
      editGoodVisible: false,
      editGoodFormRule: {
        buyNum: [
          { required: true, message: '购买数量不能为空', trigger: 'blur' }
        ]
      },

      goods_info: [],
      editVisible: false,
      editFormRule: {
        // order_amount_total: [
        //   { required: true, message: '价格不能为空', trigger: 'blur' }
        // ],
        addressName: [
          { required: true, message: '收货人不能为空', trigger: 'blur' }
        ],
        addressPhone: [
          { required: true, message: '收货人电话不能为空', trigger: 'blur' }
        ],
        addressDetail: [
          { required: true, message: '请填写收货地址', trigger: 'blur' }
        ]
      },
        //备注修改
      editBeizhuForm: {
        beizhu: null,
      },
      editBeizhuVisible:false,
      editBeizhuFormRule: {
        beizhu: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
      },

    }
  },
  watch: {
    valueId(val, oldVal) {
      if (val === oldVal) {
        return
      }
      if (this.valueId) {//编辑
        this.editForm.id = this.valueId;
        this.getDetail();
      }
    },
    visible(val, oldVal) {
      if (val === oldVal) {
        return
      }
      if (this.valueId) {//编辑
        this.editForm.id = this.valueId;
        this.getDetail();
      }
    },
  },
  mounted(){
      if (this.valueId) {//编辑
        this.editForm.id = this.valueId;
        // this.show = this.$route.query.show;
        this.getDetail();
      }
  },

  created () {
    if (this.$route.query.id) {//编辑
      this.editForm.id = this.$route.query.id;
      // this.show = this.$route.query.show;
      this.getDetail();
    }
  },

  methods: {
    // test(){
    //   alert(this.valueId);
    //   //alert(this.$route.query.id);
    //   this.editForm.id = this.valueId;
    //   //this.show = this.$route.query.show;
    //   this.getDetail();
    // },
    addGood(){
      console.log(this.valueId)
      this.visible=true
    },
    //删除商品
    async delById (order_id,goods_id,buyNum) {
      console.log(goods_id);
        if(buyNum >= 1){
          const confirmResult = await this.$confirm(
          '请先清空该商品数量',)
          return
      }
      // this.editGoodForm.buyNum = param.buyNum;
      // this.editGoodForm.g_id = param.id;
      // this.editGoodVisible = true;
      const confirmResult = await this.$confirm(
        '确定商品删除不后悔吗?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/delgoods',
        { goods_id: goods_id,order_id: order_id})
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.getDetail();
      //this.$router.push({ path: '/orders' })
    },
    editOrderQuyu(){
      this.editOrderQuyuDialogVisible = true
    },

    editOrderQuyuDialogClosed(){

    },

    //确定修改区域
   async sureEditOrderQuyu(){
        if(this.radio == 0){
        return this.$message.error("请选择区域");
      }
       const { data: res } = await this.$http.post('admin/order/sureEditQuyuOrders', {
        id: this.detailData.order_id,
        buType: this.radio,
      })
      if (res.code !== 200) {
        return this.$message.error(res.message)
      }

      this.$message.success('修改成功！')
      this.editOrderQuyuDialogVisible = false
      this.getDetail();
    },

    editOrderBeizhu(){
      this.editBeizhuVisible = true
    },

    //修改备注信息
    async submitEditOrderBeizhu(){
      if(!this.editBeizhuForm.beizhu){
        return this.$message.error("不能为空");
      }
       const { data: res } = await this.$http.post('admin/order/editOrderBeizhu', {
        order_id: this.detailData.order_id,
        beizhu: this.editBeizhuForm.beizhu,
      })
      if (res.code !== 200) {
        return this.$message.error(res.message)
      }
      this.$message.success('修改成功！')
      this.editBeizhuVisible = false
      this.getDetail();
    },

    editBeizhuDialogClosed(){
      this.$refs.editBeizhuFormRef.resetFields()
    },

    //编辑商品
    async editById (param) {
      this.editGoodForm.buyNum = param.buyNum;
      this.editGoodForm.g_id = param.id;
      this.editGoodVisible = true;
    },
    editGoodDialogClosed () {
      this.$refs.editGoodFormRef.resetFields()
    },
    //修改商品确定
    async changeGoodClick () {
      const { data: res } = await this.$http.post('admin/order/changeOrderGoodInfo', {
        g_id: this.editGoodForm.g_id,
        order_id: this.detailData.order_id,
        buyNum: this.editGoodForm.buyNum,
      })
      if (res.code !== 200) {
        return this.$message.error(res.message)
      }
      this.$message.success('修改成功！')
      this.editGoodVisible = false
      this.getDetail();
    },

    getSrcList (index) {
      return this.detailData.refund.tuikuanPingzheng.slice(index).concat(this.detailData.refund.tuikuanPingzheng.slice(0, index))
    },

    // 编辑
    editOrder (id) {
      console.log(id);
      this.$router.push({ path: '/order/detail', query: { id: id } })
    },

    //同意退款
    async agreenTuiKuan () {
      const { data: res } = await this.$http.post('admin/order/agreenRefundOrder', { id: this.editForm.id })
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.$message.success('操作成功！')
      this.getDetail();

    },

    //拒绝退款
    async refuseTuiKuan () {
      const { data: res } = await this.$http.post('admin/order/refuseRefundOrder', { id: this.editForm.id })
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.$message.success('操作成功！')
      this.getDetail();
    },

    // 删除
    async deleteOrder () {
      const confirmResult = await this.$confirm(
        '订单删除后将不可找回,是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/delete',
        { id: this.editForm.id })
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.$router.push({ path: '/orders' })
    },

    // 批量确认订单 确认1 ,发货2,已完成3, 取消6
    async sureOrder () {
      const confirmResult = await this.$confirm(
        '将确认所有已选中的待确认订单，其余订单确认无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/getOrderInfo', {
        data: this.multipleSelection,
        type: 1,
      })
      if (res.code !== 200) {
        return this.$message.error('确认订单失败！')
      }
      this.$message.success('确认订单成功！')
    },

    async getDetail () {
      const { data: res } = await this.$http.get('admin/order/getOrderInfo',
        {
          params: {
            order_id: this.editForm.id
          }
        })
      if (res.code !== 200) {
        return this.$message.error('获取商品信息失败！')
      }
      console.log(res)
      this.detailData = res.result
      this.editForm.order_amount_total = res.result.order_amount_total
      this.editForm.addressName = res.result.addressName
      this.editForm.addressPhone = res.result.addressPhone
      this.editForm.addressDetail = res.result.addressDetail
      this.editBeizhuForm.beizhu = res.result.beizhu
      this.radio = res.result.buTypeNum
      if (window.sessionStorage.getItem('pathCanLook') == 2) {
        //仅查看
        this.show = 2
      }
    },

    // 修改订单信息
    editOrder () {
      this.editVisible = true
    },

    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },

    // 修改订单信息
    async changeOrderClick () {
      
      this.$refs.cancelFormRef.validate(async valid => {
        alert(valid)
        if (!valid) return
        const { data: res } = await this.$http.post('admin/order/changeOrderInfo',
          this.editForm)
        if (res.code !== 200) {
          return this.$message.error('操作失败！')
        }
        this.editVisible = false
        this.getDetail()
      })
    },

    cancelDialogClosed () {
      this.cancelVisible = false;
      this.cancelForm.cancelSeasion = null
    },

    cancelOrder () {
      this.cancelVisible = true
    },

    // 取消订单
    async cancelOrderClick () {
      this.$refs.cancelFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/order/cancelOrderInfo',
          {
            order_id: this.editForm.id,
            cancelSeasion: this.cancelForm.cancelSeasion,
          })
        if (res.code !== 200) {
          return this.$message.error('操作失败！')
        }
        this.cancelVisible = false
        this.getDetail()
      })
    },
  }
}

</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}

.title {
  color: #999999;
  text-align: center;
  font-size: 18px;
}
.el-row {
  margin-top: 30px;
}
</style>
